module.exports = __webpack_public_path__ + "aa3d2bc2a40c5813a0e49741a88b156d.pdf";